<template>
  <div class="page-content">
    <main class="authorize-main">
      <div class="authorize-wrapper flex">
        <div class="authorize-text">
          <div class="authorize-logo">
            <svg class="svg-logo">
              <use href="/img/logo.svg#svg-logo"></use>
            </svg>
          </div>
          <div class="authorize-title">
            <div class="h2">
              <span class="txt-accent">Войдите</span> в&nbsp;свою учетную запись
            </div>
            <p class="font-14">Если у вас нет учетной записи, обратитесь к&nbsp;руководителю вашей компании/отдела</p>
          </div>
        </div>
        <!--Наличие пустого placeholder=" " с одним пробелом внутри - важно для анимации фейк-плейсхолдера-->
        <div class="authorize-form-wrapper">
          <Form :validation-schema="dynamicSchema"
                v-slot="{ errors, meta, handleSubmit, setFieldValue, resetForm }"
                :initial-values="user"
                :validateOnMount="false"
                v-bind="validateMode"
                @invalid-submit="handleInvalidSubmit"
          >
            <form @submit.prevent="handleSubmit((values) => onSubmit(values, resetForm))" class="authorize-form" autocomplete="off">
              <div class="error-tooltip" v-if="Object.keys(errors).length > 0">
                <span v-for="(error, key) in errors" :key="key">{{ error }}<br/></span>
              </div>
              <div class="error-tooltip" v-if="serverError">
                <span v-html="serverError"></span>
              </div>
              <Field v-slot="{ value, handleChange, field, errorMessage, handleBlur }" name="login">
            <div class="form-item has-placeholder" :class="{'not-valid': errorMessage}">
              <span class="input-icon">
                <svg class="svg-user">
                  <use href="/img/sprite.svg#svg-user"></use>
                </svg>
              </span>
              <input class="input" type="text" :value="value"
                     @input="(e) => { handleChange(e, !!errorMessage); login = e.target.value; }"
                     @blur="handleBlur" autocomplete="login" placeholder=" ">
              <span class="fake-placeholder">Логин</span>
            </div>
              </Field>
              <Field v-slot="{ value, handleChange, field, errorMessage, handleBlur  }" name="password">
            <div class="form-item form-passw has-placeholder" :class="{'not-valid': errorMessage, 'form-passw-active':showPassword}">
              <span class="input-icon">
                <svg class="svg-lock">
                  <use href="/img/sprite.svg#svg-lock"></use>
                </svg>
              </span>
              <input class="input" :type="!showPassword ? 'password' : 'text'" :value="value"
                     @input="(e) => { handleChange(e, !!errorMessage); password = e.target.value; }"
                     @blur="handleBlur" autocomplete="password" placeholder=" ">
              <span class="fake-placeholder">Пароль</span>
              <span class="show-passw btn-square" @click="showPassword = !showPassword"></span>
            </div>
              </Field>
              <Field v-slot="{ field, errorMessage }" name="remember">
            <label class="checkbox-label mt-10">
              <input type="checkbox" v-model="remember">
              <span class="fake-checkbox"></span>
              <span class="checkbox-name">Запомнить меня</span>
            </label>
              </Field>
            <div class="form-button mt-15">
              <button class="btn w-100" :class="{loader:isSubmitting}" type="submit">Войти</button>
            </div>
          </form>
          </Form>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
import scrollToError from "@/mixin/scrollToError.vue";
import { Form, Field, useForm } from 'vee-validate';
import * as yup from 'yup';

export default {
  components: {
    Form, Field
  },
  mixins: [scrollToError],
  data: () => ({
    login: '',
    password: '',
    remember: false,
    isSubmitting: null,
    serverError: null,
    successMessage: null,
    showPassword: false
  }),
  computed: {
    dynamicSchema() {
      return yup.object({
        login: yup
            .string()
            .required('Логин обязателен для заполнения')
            .min(3, 'Логин должен содержать минимум 3 символа')
            .max(50, 'Логин не должен превышать 50 символов')
            .matches(/^[a-zA-Z0-9_-]+$/, 'Логин может содержать только латинские буквы, цифры, дефис и подчеркивание'),

        password: yup
            .string()
            .required('Пароль обязателен для заполнения')
            .min(6, 'Пароль должен содержать минимум 6 символов')
            .max(100, 'Пароль не должен превышать 100 символов'),

        remember: yup.boolean()
      });
    },
    validateMode() {
      return {
        validateOnBlur: true,
        validateOnChange: false,
        validateOnInput: false,
        validateOnModelUpdate: false
      };
    }
  },
  methods: {
    handleInvalidSubmit() {
      this.scrollToFirstError();
    },

    async onSubmit(values, resetForm) {
      this.isSubmitting = true;
      this.serverError = null;
      this.successMessage = null;

      const formDataToSubmit = {
        login: this.login,
        password: this.password,
        remember: this.remember,
      };

      try {


        // отправка данных на сервер
        const response = await axios.post('/api/user/login/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        else {
          this.$store.commit('Auth', response.data.data);
          if (this.$store.getters.isAuth && this.$store.getters.user?.role === 'supplier') {
            this.$i18n.locale = 'en'
            this.$store.commit('setLang', 'en')
          }

          this.$router.push({ name: 'main' });
        }

      } catch (error) {
        //this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
  }
}
</script>
